import { atom } from "jotai";
import {
  emitAiPredictionOutputEventSetter,
  zslFeedbackPredictionIdAtom,
  uuid,
  zslAtom,
} from "@zapier/canvas-state";
import { isJsonString, removeIndexingFromZsl, systems } from "../utils";
import { aiPromptAtom } from "./aiPromptAtom";
import { outlineAtom } from "./outlineAtom";
import { zslOutlineToNodesAndEdgesSetter } from "./zslOutlineToNodesAndEdgesSetter";

export const renderZslToCanvasSetter = atom(null, async (get, set) => {
  const zsl = get(zslAtom);
  if (!zsl) return;

  const modifiedZsl = removeIndexingFromZsl(zsl);
  const prompt = get(aiPromptAtom);
  const outline = get(outlineAtom);

  const prediction_id = uuid();
  set(zslFeedbackPredictionIdAtom, prediction_id);

  const isHardcoded = systems.some((role) =>
    role.systems.some(
      (system) =>
        system.prompt.includes(prompt) || prompt.includes(system.prompt),
    ),
  );

  let outlineObject: object | string;
  if (isJsonString(outline)) {
    outlineObject = JSON.parse(outline);
  } else {
    outlineObject = outline;
  }

  // If outline exists, update nodes and edges
  if (outline) {
    set(zslOutlineToNodesAndEdgesSetter);
  }

  set(emitAiPredictionOutputEventSetter, {
    prediction_id,
    correlation_id: null,
    prediction_json_input: JSON.stringify({ prompt, isHardcoded }),
    prediction_json_output: JSON.stringify({
      outline: outlineObject,
      zsl: modifiedZsl,
    }),
    prediction_source: "canvas.creation",
  });
});

renderZslToCanvasSetter.debugLabel = "renderZslToCanvasSetter";
